// Shared helpers of the quote request scripts.

export const $ = (s, r = document) => r.querySelector(s)
export const $$ = (s, r = document) => Array.from(r.querySelectorAll(s))
export const show = (el, on) => el && el.classList.toggle('d-none', !on)
export const isShown = (el) => !!el && !el.classList.contains('d-none')
export const esc = (s) =>
  String(s ?? '').replace(
    /[&<>"']/g,
    (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[
        c
      ]
  )
export const nf = (n) => Number(n).toLocaleString('fr-FR')

// Sends the JSON request to admin-ajax.php?action=vn_quote.
export const postQuote = async (data) => {
  const res = await fetch(window.vnQuote.endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(data),
  })
  return res.json()
}
